<template>
  <div class="level-beta-notice" :class="{ 'level-beta-notice--active': isActive }" role="note">
    <span class="level-beta-notice__badge">{{ isActive ? 'ACTIVO' : 'BETA' }}</span>
    <div v-if="isActive">
      <strong>Pago por nivel — activo desde la semana del {{ activeFromLabel }}.</strong>
      Tu pago semanal se calcula con tu nivel: el porcentaje del monto vendido depende de si estás en A, B o C.
      Ya no se descuentan tardanzas ni reclamos; tu nivel es lo que cuenta. Mejora tu nivel y cobras más.
    </div>
    <div v-else>
      <strong>Pago por nivel — en fase de prueba.</strong>
      Tu nivel se calcula cada quincena y lo seguimos ajustando. Por ahora <strong>no cambia tu pago</strong>:
      tu consolidado se sigue armando como siempre. Cuando el pago por nivel se active, te avisaremos con anticipación.
    </div>
  </div>
</template>

<script>
const ACTIVE_FROM = process.env.VUE_APP_PAY_BY_LEVEL_FROM || '';
const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;
const DATE_PART_LENGTH = 2;
const MONTH_OFFSET = 1;

function localToday() {
  const now = new Date();
  const pad = value => String(value).padStart(DATE_PART_LENGTH, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + MONTH_OFFSET)}-${pad(now.getDate())}`;
}

export default {
  name: 'LevelPaymentBetaNotice',
  computed: {
    isActive() {
      if (!ISO_DATE.test(ACTIVE_FROM)) return false;
      return localToday() >= ACTIVE_FROM;
    },
    activeFromLabel() {
      const [, , month, day] = ACTIVE_FROM.match(ISO_DATE) || [];
      return `${day}/${month}`;
    },
  },
};
</script>

<style scoped>
.level-beta-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  margin-bottom: 14px;
  border-radius: 8px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  color: #7c2d12;
  font-size: 13px;
  line-height: 1.4;
}
.level-beta-notice__badge {
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 999px;
  background: #f97316;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
}
.level-beta-notice--active {
  background: #f0fdf4;
  border-color: #bbf7d0;
  color: #14532d;
}
.level-beta-notice--active .level-beta-notice__badge {
  background: #16a34a;
}
</style>
